import events from '../../../../../events.js'

const {SIGNED_IN, SIGNED_UP} = events

const TOTAL_SIGNED_IN_OR_SIGNED_UP = {
  EVENTS: [SIGNED_IN, SIGNED_UP],
  EVENT_OPTIMIZELY: 'Total Signed In or Signed Up'
}

export const getAuthenticationEvents = ({event}) => {
  if (!TOTAL_SIGNED_IN_OR_SIGNED_UP.EVENTS.includes(event)) return []
  return [TOTAL_SIGNED_IN_OR_SIGNED_UP.EVENT_OPTIMIZELY]
}
